// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"e4d01b6a","485":"d3586865","555":"657607b6","643":"6c95802b","711":"ce179b45","713":"7140e8dc"}[chunkId] + ".chunk.js";
};